const FormFieldTextarea = ({
    label,
    fieldName,
    value,
    defaultValue,
    stateObject,
    updateStateObject,
    required = false,
    formatValue = null,
    className = '',
    additionalProps = {},
    readOnly = false,
    description = '',
    rows = 4
}) => {
    return (
        <div className={`formField formField-textarea ${className}`}>
            <label>{label}{required ? "*" : ""}: </label>
            {description && <span className="formField-description">{description}</span>}
            <textarea
                defaultValue={defaultValue}
                value={value}
                onChange={(e) => updateStateObject({
                    ...stateObject,
                    [fieldName]: formatValue ? formatValue(e.target.value) : e.target.value
                })}
                name={fieldName}
                required={required}
                {...additionalProps}
                readOnly={readOnly}
                rows={rows}
            />
        </div>
    )
}

export default FormFieldTextarea;